export const RECEIVE_WIZARD_ASSIGNMENT_OPTIONS = 'RECEIVE_WIZARD_ASSIGNMENT_OPTIONS';
export const RECEIVE_WIZARD_PANELS = 'RECEIVE_WIZARD_PANELS';
export const SELECT_WIZARD_OPTION = 'SELECT_WIZARD_OPTION';
export const EXPAND_WIZARD_OPTION = 'EXPAND_WIZARD_OPTION';
export const WIZARD_ADVANCE = 'WIZARD_ADVANCE';
export const WIZARD_REWIND = 'WIZARD_REWIND';
export const WIZARD_GOTO = 'WIZARD_GOTO';
export const WIZARD_RESET = 'WIZARD_RESET';
export const WIZARD_SUBMITTED = 'WIZARD_SUBMITTED';
export const WIZARD_ENABLE_SUMMARY_MODE = 'WIZARD_ENABLE_SUMMARY_MODE';
export const WIZARD_DISABLE_SUMMARY_MODE = 'WIZARD_DISABLE_SUMMARY_MODE';
export const SELECT_WIZARD_ASSIGNMENT = 'SELECT_WIZARD_ASSIGNMENT';

export const ASSIGNMENTS_PANEL_INDEX = 1;

// Panel types
export const MULTIPLE_CHOICE_PANEL = 0;
export const SINGLE_CHOICE_PANEL = 1;
export const CUSTOM_PANEL = -1;
